import useHasPermission from './useHasPermission';

const useTableActions = ({
  updatePermission,
  deletePermission,
  editURL,
  removePATH,
  createPermission,
  viewPermission = '',
}) => {
  const useHasUpdatePermission = useHasPermission(updatePermission);
  const useHasDeletePermission = useHasPermission(deletePermission);
  const useHasCreatePermission = useHasPermission(createPermission);
  const useHasViewPermission = useHasPermission(viewPermission);
  return [
    useHasUpdatePermission ? editURL : null,
    removePATH && useHasDeletePermission ? removePATH : null,
    useHasCreatePermission,
    useHasViewPermission ? editURL : null,
  ];
};

export default useTableActions;
